const MIN_YEAR = 2009;

export const DATE_RANGE = {
  min: new Date(MIN_YEAR, 0, 1),
  max: new Date(new Date().setHours(0, 0, 0, 1)), // +1ms is necessary for mantine to correctly include max month on its first day
};
